<template>
  <testate :filtraTipiDocumento="filtraTipiDocumento" @apriDettaglio="apriDettaglio"/>
</template>

<script>
  import moment from 'moment'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import { insomnia } from '@/components/insomnia'
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import Testate from './components/testate'
  import configurazioni from '@/services/configurazioniService'
  import prodotti from '@/services/prodottiService.js'

  export default {
    components: {
      Testate
    },
    mixins: [verificaLicenza, insomnia],
    data: () => ({
      step: 1,
      chiaveDocumento: null,
      filtraTipiDocumento: [],
      updateInterval: null,
      istanteAggiornamento: null
    }),
    async mounted() {
      await this.gestioneToken()
      const tipiDocumento = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
      let tipiFiltrati = tipiDocumento.filter(x => !['preventivoCliente', 'ordineCliente', 'ordineFornitore', 'ddtFornitore', 'autofattura', 'ordineMultiplo'].includes(x.tipoDocumento))
      this.filtraTipiDocumento = tipiFiltrati.filter(x => x.inserimentoManuale).sort(dynamicSortMultiple('ordine', 'descrizione'))
      this.$store.commit('documenti/SET_PAGE', 'testata')
      await configurazioni.caricaCacheDefault()
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      if (_.get(impostazioni, 'prodotti.abilitaProdottiPreCache', true)) {
        await prodotti.popolaPreCache(true)
      }
      if (_.get(impostazioni, 'timerVerificaSincronizzazione', true)) {
        await this.verificaAggiornamento()
        this.updateInterval = setInterval(async () => {
          await this.verificaAggiornamento()
        }, 5 * 60 * 1000)
      }
    },
    computed: {
      gotoBase() {
        return this.$store.getters['documenti/gotoBase']
      }
    },
    watch: {
      gotoBase(value) {
        if (value) {
          this.step = 1
          this.$store.commit('documenti/CLEAR_GOTO_BASE')
        }
      }
    },
    methods: {
      async verificaAggiornamento() {
        console.log('entrato')
        if (!this.istanteAggiornamento || moment().isAfter(moment(this.istanteAggiornamento).add(10, 'minutes'))) {
          // Aggiornare
          console.log('aggiornare')
          await this.cicleSyncProcess()
        }
        this.istanteAggiornamento = moment()
      },
      apriDettaglio(chiave) {
        // console.log('chiave', chiave)
        this.chiaveDocumento = chiave
        this.$store.commit('documenti/SET_PAGE', 'dettaglio')
        this.step = 2
      },
      tornaIndietro() {
        this.step = 1
        this.$store.commit('documenti/SET_PAGE', 'testata')
        this.$store.commit('documenti/SET_CHIAVE', null)
        this.$store.commit('documenti/CLEAR_DOCUMENTO')
        this.chiaveDocumento = null
      }
    }
  }
</script>
